var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIdle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00083 14.1594C9.0144 14.2729 9.00186 14.3879 8.96416 14.4958C8.92647 14.6037 8.86462 14.7016 8.78333 14.7819C8.64281 14.9216 8.45272 15 8.25458 15C8.05644 15 7.86635 14.9216 7.72583 14.7819L4.72583 11.7819C4.64213 11.7015 4.57824 11.6027 4.5392 11.4934C4.50015 11.384 4.48702 11.2672 4.50083 11.1519V7.31189L0.908331 2.71439C0.786537 2.55804 0.731581 2.35983 0.755472 2.16309C0.779362 1.96634 0.880157 1.78705 1.03583 1.66439C1.16779 1.55852 1.33166 1.50037 1.50083 1.49939H12.0008C12.17 1.50037 12.3339 1.55852 12.4658 1.66439C12.6215 1.78705 12.7223 1.96634 12.7462 2.16309C12.7701 2.35983 12.7151 2.55804 12.5933 2.71439L9.00083 7.31189V14.1594ZM3.00083 2.99939L6.00083 6.79439V10.9344L7.50083 12.4344V6.78689L10.5008 2.99939M9.75083 11.9994L13.5008 15.7494L17.2508 11.9994H9.75083Z",
    fill: "#A9ADCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIdle);
export default __webpack_public_path__ + "static/media/filter_idle.2de47993c7a5b877f4051ec5410f50ec.svg";
export { ForwardRef as ReactComponent };